import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function SimpleBackdrop({ open, handleClose, childComponent }) {

  return (
    <div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        {
          childComponent === "loader" ?
          <CircularProgress color="inherit" />
          :
          <iframe style={{zIndex: '100'}} width="560" height="315" src="https://www.youtube.com/embed/rKu6TBF8YRQ" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        }
      </Backdrop>
    </div>
  );
}
                              